import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const ForgotPasswordForm = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(0),
}));
